module.exports = __webpack_public_path__ + "img/04-3-5低成本.a1b08c1c.svg";